import styled from "@emotion/styled"

export const Container = styled.div`
  background-Color:${props => props.theme.palette.color.backGround};;
  width: 100%;
  height: 100%;
  padding: 10px ;

`